import {
  CREATE_OFFENSE_REQUEST,
  CREATE_OFFENSE_SUCCESS,
  CREATE_OFFENSE_FAILURE,
  FETCH_OFFENSES_REQUEST,
  FETCH_OFFENSES_SUCCESS,
  FETCH_OFFENSES_FAILURE,
  UPDATE_OFFENSE_REQUEST,
  UPDATE_OFFENSE_SUCCESS,
  UPDATE_OFFENSE_FAILURE,
  DELETE_OFFENSE_REQUEST,
  DELETE_OFFENSE_SUCCESS,
  DELETE_OFFENSE_FAILURE,
  UPLOAD_OFFENSE_REQUEST,
  UPLOAD_OFFENSE_SUCCESS,
  UPLOAD_OFFENSE_FAILURE,
  DOWNLOAD_TEMPLATE_REQUEST,
  DOWNLOAD_TEMPLATE_SUCCESS,
  DOWNLOAD_TEMPLATE_FAILURE,
  SET_UPLOAD_PROGRESS,
} from "../../actions/survey-management/offenseMasterActions";

const initialState = {
  loading: false,
  offenses: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  uploadProgress: 0,
  error: null,
  lastUpload: null,
};

const offenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_OFFENSE_REQUEST:
    case FETCH_OFFENSES_REQUEST:
    case UPDATE_OFFENSE_REQUEST:
    case DELETE_OFFENSE_REQUEST:
    case UPLOAD_OFFENSE_REQUEST:
    case DOWNLOAD_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_OFFENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case FETCH_OFFENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        offenses: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case UPDATE_OFFENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case DELETE_OFFENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case UPLOAD_OFFENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        lastUpload: action.payload,
        error: null,
      };

    case DOWNLOAD_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload,
      };

    case CREATE_OFFENSE_FAILURE:
    case FETCH_OFFENSES_FAILURE:
    case UPDATE_OFFENSE_FAILURE:
    case DELETE_OFFENSE_FAILURE:
    case UPLOAD_OFFENSE_FAILURE:
    case DOWNLOAD_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default offenseReducer;
